import React from 'react';
import AuctionBanner from "./components/AuctionBanner";
import Auctions from "./components/Auctions"
import Page from "src/components/Page";
function Index(props) {
 
    return (
        <>

        <Page >
                  <AuctionBanner/>
                  
                  <Auctions/>
                  
        </Page>
        </>
    );
}

export default Index;


